import { ActionReducerMap } from "@ngrx/store";
import { AppState } from "./app.state";
import { authReducer } from "./auth/auth.reducer";
import { layoutReducer } from "./layout/layout.reducer";
import { paginationFilterReducer } from "./paginationFilter/paginationFilter.reducer";

export const reducers: ActionReducerMap<AppState> = {
    auth: authReducer,
    layout: layoutReducer,
    paginationFilter: paginationFilterReducer
};